import { render, staticRenderFns } from "./Favorites.vue?vue&type=template&id=ff2c7c86&scoped=true&lang=pug&"
import script from "./Favorites.vue?vue&type=script&lang=ts&"
export * from "./Favorites.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2c7c86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff2c7c86')) {
      api.createRecord('ff2c7c86', component.options)
    } else {
      api.reload('ff2c7c86', component.options)
    }
    module.hot.accept("./Favorites.vue?vue&type=template&id=ff2c7c86&scoped=true&lang=pug&", function () {
      api.rerender('ff2c7c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/job-components/Favorites.vue"
export default component.exports